

import Grid from '@mui/material/Grid';
import { Typography, IconButton, Box, Chip, TextField, Button, InputAdornment, Dialog, DialogTitle, DialogContent, Switch, FormControlLabel, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useEffect, useContext, useState } from 'react';
import { Helmet } from 'react-helmet';
import ThemeProvider from '../theme';
import Paper from '@mui/material/Paper';
import { UserContext } from '../assets/contexts/userContext';
import Avatar from '@mui/material/Avatar';
import EditIcon from '@mui/icons-material/Edit';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import * as utils from '../assets/js/utils';
import * as endPoints from '../assets/js/endpoints';
import { useFadeInOnScroll } from '../theme/global';
import { useNotification } from '../assets/contexts/notificationContext';
import fondo2 from '../assets/images/fondos/5_color.png';

function Profile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { user, updateAvatar, updateName, updateLastName } = useContext(UserContext);
  const containerRef = useFadeInOnScroll();
  const [hover, setHover] = useState(false);
  const [nameHover, setNameHover] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [name, setName] = useState(user.name);
  const [lastName, setLastName] = useState(user.lastName);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const { showNotification, reminderConfig, updateReminderConfig } = useNotification();
  const [appointments, setAppointments] = useState([]);

  const validatePassword = p => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(p);

  const handleNameUpdate = async e => {
    e.preventDefault();
    try {
      await endPoints.updateUser(user.id, name, lastName, user.email, user.role);
      updateName(name);
      updateLastName(lastName);
      showNotification('Nombre actualizado', 'success');
      setEditingName(false);
    } catch (_err) {
      showNotification('Error actualizando el nombre', 'error');
    }
  };

  const handlePasswordUpdate = async e => {
    e.preventDefault();
    if (!validatePassword(password)) {
      showNotification('La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número', 'error');
      return;
    }
    if (password !== confirm) {
      showNotification('Las contraseñas no coinciden', 'error');
      return;
    }

    try {
      await endPoints.updatePassword(currentPassword, password, confirm);
      showNotification('Contraseña actualizada', 'success');
      setCurrentPassword('');
      setPassword('');
      setConfirm('');
      setPasswordOpen(false);
    } catch (_err) {
      showNotification('Error actualizando la contraseña', 'error');
    }
  };

  const handleChange = async (e) => {
    if (!e.target.files || !e.target.files[0]) return;
    const formData = new FormData();
    formData.append('avatar', e.target.files[0]);
    try {
      const res = await endPoints.updateAvatar(formData);
      const newAvatar = `${utils.image_path(res.avatar)}?t=${Date.now()}`;
      updateAvatar(newAvatar);
    } catch (_err) {
    }
  };

  const infoCards = [
    // { label: 'Rol', value: utils.roleToSpanish(user.role) },
    { label: 'Fecha de registro', value: `${user.createDate.getDate()}/${user.createDate.getMonth() + 1}/${user.createDate.getFullYear()}` },
    { label: 'Email', value: user.email },

  ];

  useEffect(() => {
    const loadAppointments = async () => {
      try {
        const data = await endPoints.getAppointmentsByRole(user.role, user.id);
        const now = new Date();
        const limit = 15 * 24 * 60 * 60 * 1000; // 15 días
        const upcoming = (Array.isArray(data) ? data : [])
          .filter(a => {
            const dt = new Date(`${a.date}T${a.time || '00:00'}`);
            return dt > now && dt - now <= limit;
          })
          .sort(
            (a, b) =>
              new Date(`${a.date}T${a.time || '00:00'}`) -
              new Date(`${b.date}T${b.time || '00:00'}`)
          );
        setAppointments(upcoming);
      } catch (_err) {
      }
    };
    if (user.id !== null) loadAppointments();
  }, [user.id, user.role]);

  return (
    <>
    <Helmet>
      <title>Perfil | CES</title>
      <meta name="description" content="Gestiona la información de tu cuenta." />
    </Helmet>
    <ThemeProvider>
      <Grid
        container
        ref={containerRef}
        spacing={2}
        className="fade-up"
        mt={2}
        sx={{ py: 5, px: 2 }}
      >
        {/* Header */}
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              mb: 2,
              width: '100%',
              mx: 'auto',
              borderRadius: 1,
              backgroundImage: `url(${fondo2})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative'
            }}
          >
            <Grid container alignItems="center" p={3} justifyContent='space-around'>
               <Grid container xs={12} sm={12} md={10} alignItems="center">
              <Grid item xs={12} sm={2} md={1} >
                <Box
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  sx={{ position: 'relative', width: 100, height: 100, }}
                >
                  <Avatar
                    src={user.avatar}
                    alt={`${user.name} ${user.lastName} avatar`}
                    variant="rounded"
                    sx={{ width: '100%', height: '100%' }}
                  />
                  {hover && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 1
                      }}
                    >
                      <IconButton component="label">
                        <EditIcon sx={{ color: '#fff' }} />
                        <input hidden type="file" accept="image/*" onChange={handleChange} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={10} md={3}>
                <Box
                  onMouseEnter={() => setNameHover(true)}
                  onMouseLeave={() => setNameHover(false)}
                  sx={{ position: 'relative', display: 'flex', flexDirection: { xs: 'column', sm: 'column' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: 1 }}
                >
                  {editingName ? (
                    <Box component="form" onSubmit={handleNameUpdate} sx={{ display: 'flex', alignItems: 'center', justifyContent:'center', gap: 1, flexWrap: 'wrap', width: 'max-content' }}>
                      <TextField value={name} size="small" onChange={e => setName(e.target.value)} autoFocus />
                      <TextField value={lastName} size="small" onChange={e => setLastName(e.target.value)} />
                      <IconButton type="submit" color="primary" size="small"><CheckIcon /></IconButton>
                      <IconButton onClick={() => { setEditingName(false); setName(user.name); setLastName(user.lastName); }} size="small"><CloseIcon /></IconButton>
                    </Box>
                  ) : (
                    <>
                      <Typography variant="h4" fontWeight="bold">
                        {name} {lastName}
                      </Typography>
                        <Chip label={utils.roleToSpanish(user.role)} size="small" />
                      {nameHover && (
                        <IconButton onClick={() => setEditingName(true)} size="small" sx={{ position: 'absolute', top: 0, right: 0 }}>
                          <EditIcon />
                        </IconButton>
                      )}
                    </>
                  )}
               
                </Box>                 
              </Grid>
             </Grid>
              <Grid item xs={12} sm={12} md={2}>  
                  <Chip label="Actualizar contraseña"
                    onClick={() => setPasswordOpen(true)} size="small" 
                    sx={{cursor: 'pointer'}}/>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Información adicional responsive */}
        {infoCards.map(({ label, value }) => (
          <Grid key={label} item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
              <Typography variant="subtitle1" gutterBottom>
                {label}
              </Typography>
              <Typography variant="h5">{value}</Typography>
            </Paper>
          </Grid>
        ))}

        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={3} sx={{ p: 3, height: '100%', display:'flex', flexDirection:'column', gap:2 }}>
            <Typography variant="subtitle1" gutterBottom>Avisos de citas</Typography>
            <FormControlLabel
              control={<Switch checked={reminderConfig.enabled} onChange={e => updateReminderConfig({ enabled: e.target.checked })} />}
              label="Activar"
            />
            <TextField
              label="Días de antelación"
              type="number"
              value={reminderConfig.daysBefore}
              onChange={e => updateReminderConfig({ daysBefore: Number(e.target.value) })}
              inputProps={{ min:1 }}
              size="small"
            />
          </Paper>
        </Grid>


        {/* <Grid item xs={12}>
          <Paper elevation={3} sx={{ p:3 }}>
            <Typography variant="subtitle1" gutterBottom>
              Próximas citas (15 días)
            </Typography>
            {appointments.length > 0 ? (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Cliente</TableCell>
                      <TableCell>Servicio</TableCell>
                      <TableCell>Fecha</TableCell>
                      <TableCell>Hora</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {appointments.map(a => (
                      <TableRow key={a.id}>
                        <TableCell>{(a.client_name && a.client_name !== 'null') ? a.client_name : 'Sin cliente'}</TableCell>
                        <TableCell>{a.service_name}</TableCell>
                        <TableCell>{a.date}</TableCell>
                        <TableCell>{(a.time || '').substring(0,5)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>Aún no hay citas concertadas</Typography>
            )}
          </Paper>
        </Grid> */}


        {/* Actualizar contraseña */}
        {/* <Grid item xs={12} sm={6} md={4}>
          <Box elevation={3} sx={{ p: 3, textAlign: 'center' }}>
            <Button variant="contained" onClick={() => setPasswordOpen(true)}>
              Actualizar contraseña
            </Button>
          </Box>
        </Grid> */}
      </Grid>
      <Dialog open={passwordOpen} onClose={() => setPasswordOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{textAlign:'center', fontWeight: 600, mt:1}}>Actualizar contraseña</DialogTitle>
        <DialogContent sx={{ display: 'grid', gap: 3, p: 3 }}>
          <TextField
            sx={{mt: 2}}
            label="Contraseña actual"
            type={showPass ? 'text' : 'password'}
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(p => !p)} edge="end">
                    {showPass ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            label="Nueva contraseña"
            type={showPass ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(p => !p)} edge="end">
                    {showPass ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            label="Confirmar contraseña"
            type={showConfirm ? 'text' : 'password'}
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirm(p => !p)} edge="end">
                    {showConfirm ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button variant="contained" onClick={handlePasswordUpdate}>Guardar</Button>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
    </>
  );
}

export default Profile;
